(() => {
  const update = () => {
    document.querySelectorAll('[data-lv-footer-menu]').forEach(el => {
      const desktop = matchMedia('(min-width: 750px)').matches;
      if (desktop || el.dataset.accordion !== 'true') el.open = true;
      else if (el.dataset.viewport !== 'mobile') el.open = false;
      el.dataset.viewport = desktop ? 'desktop' : 'mobile';
    });
    document.querySelectorAll('.cart__ctas').forEach(el => {
      const fallback = el.querySelector('.lv-standard-checkout');
      const accelerated = el.querySelector('.additional-checkout-buttons');
      if (!fallback) return;
      const wallet = accelerated?.querySelector('shopify-accelerated-checkout-cart');
      const nativeButtons = accelerated?.querySelector('iframe, button, [role="button"]');
      const ready = (wallet && wallet.shadowRoot && wallet.shadowRoot.querySelector('button,iframe,[role="button"]')) || nativeButtons;
      const visible = ready && accelerated.getBoundingClientRect().height > 35;
      fallback.hidden = Boolean(visible);
    });
  };
  let scheduled = false;
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; update(); }); } };
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  update();
  setTimeout(update, 1500);
  setTimeout(update, 5000);
})();

if (!customElements.get('lv-cart-recommendations')) {
 customElements.define('lv-cart-recommendations', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.loaded) return;
   this.dataset.loaded = 'true';
   const url = new URL(this.dataset.url, location.origin);
   if (url.origin !== location.origin) return;
   fetch(url).then(r => { if (!r.ok) throw new Error('Recommendations unavailable'); return r.text(); }).then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.querySelector('[data-lv-recommendation-results]');
    if (this.isConnected && content?.querySelector('.lv-card')) this.replaceChildren(content);
   }).catch(() => {});
  }
 });
}

if (!customElements.get('cv-collection-tabs')) {
 customElements.define('cv-collection-tabs', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   const tabs = [...this.querySelectorAll('[data-cv-tab]')];
   const panels = [...this.querySelectorAll('[data-cv-panel]')];
   if (!tabs.length || tabs.length !== panels.length) return;
   this.dataset.ready = 'true';
   this.querySelector('[data-cv-tabs]').setAttribute('role','tablist');
   const select = (index, focus = false) => {
    tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
    if (focus) tabs[index].focus();
    this.querySelector('[data-cv-status]').textContent = tabs[index].textContent.trim();
   };
   tabs.forEach((tab, i) => {
    tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panels[i].id);
    panels[i].setAttribute('role','tabpanel');panels[i].tabIndex=0;
    tab.addEventListener('click',e=>{e.preventDefault();select(i);});
    tab.addEventListener('keydown',e=>{
     let n=i;
     if(e.key==='ArrowRight')n=(i+1)%tabs.length;
     else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;
     else if(e.key==='Home')n=0;
     else if(e.key==='End')n=tabs.length-1;
     else if(e.key===' '||e.key==='Enter'){e.preventDefault();select(i);return;}
     else return;
     e.preventDefault();select(n,true);
    });
   });
   select(0);
   this.addEventListener('shopify:block:select',e=>{const i=panels.findIndex(p=>p.contains(e.target)||p===e.target);if(i>=0)select(i);});
  }
 });
}
